import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import { StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { ElevatorPanelSmall } from '../Components/ElevatorPanel/ElevatorPanelSmall';
import { MapCloseButton } from '../Components/MapCloseButton';
import { MapPage } from '../Components/MapPage/MapPage';
import { useFloorMapPresenter } from '../FloorMapPresenter';
import { MapLayoutPortrait } from './MapLayoutPortrait';

export const MapPortrait = observer(function MapPortrait() {
  const { title, floorsVM } = useFloorMapPresenter();

  return (
    <MapLayoutPortrait
      mapComponent={
        <MapContainer>
          {floorsVM.map((floor) => (
            <MapPage floorId={floor.id} key={floor.id} />
          ))}
        </MapContainer>
      }
      titleComponent={<MapTitle style={styles.title}>{title}</MapTitle>}
      closeButtonComponent={<MapCloseButton size={27} />}
      elevatorPanelComponent={<ElevatorPanelSmall />}
    />
  );
});

const MapContainer = styled.View`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  padding-top: 20px;
`;

const MapTitle = styled.Text`
  font-size: 50px;
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  color: ${OwnableTheme.colors.white};
`;

const styles = StyleSheet.create({
  title: { fontSize: 24 },
});
